import { Ref } from '@vue/composition-api';
import { getGroupMembersStore, GroupMembersStore } from '../modules/groupMembers';
import { GroupsStore } from './Groups';
import { UserStore } from './User';

const globalCache = {};
const globalCountsCache = {};

export const useGroupMembersStore = (currentGroupId: Ref<string>): GroupMembersStore => getGroupMembersStore(
	currentGroupId,
	globalCache,
	globalCountsCache,
	UserStore.getInstance(),
	GroupsStore.getInstance(),
);
